import { useNavigate } from 'react-router-dom'
import { useAuth } from '../App.jsx'
import RegisterForm from './RegisterForm.jsx'

export default function RegisterPage() {
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleRegister = () => {
    login()
    navigate('/', { replace: true })
  }

  return <RegisterForm onRegister={handleRegister} onToggleLogin={() => navigate('/login')} />
}
